import React from "react"
import styles from "./Modal.module.css"

const Modal = ({ isOpen, children, onClose, className }) => {
  if (!isOpen) {
    return null
  }

  return (
    <div className={styles.backdrop}>
      <div className={`${styles.container} ${className}`}>
        {onClose && (
          <button className={styles.close} onClick={onClose}>
            &times;
          </button>
        )}
        {children}
      </div>
    </div>
  )
}

export default Modal
